import {label} from "@/class/label";
import {Media} from "@/class/data-type";

export class overlay extends label{
    
    objectType = "overlay";
    parentObjectType = "interactive_image";
    
    data = [
        ...this._default.coords,
        ...this._default.pointer,
        {name: "image", type: Media, default: new Media({type:"picture"})},
        {name: "width", type:Number, default: 0.0},
        {name: "height", type:Number, default: 0.0},
        {name: "effect", type:String, default: "wave"}
    ]
    
    constructor() {
        super();
        this.init();
    }
    
    setDataReq(data, chapterId, storyId) {
    
        data["width"] = Math.floor(data.width);
        data["height"] = Math.floor(data.height);
        
        return super.setDataReq(data, chapterId, storyId);
    }
    
    getDataReq(){
        let data = super.getDataReq();
        return {
            ...data,
            width: Math.floor(data["width"]),
            height: Math.floor(data["height"]),
        }
    }
    
    getImageId(){
        return this.image.id;
    }
    
}